import httpCommon from "./http-common";

// Get user
const getUser = (publicId: string) => {
  return httpCommon.get(`/v1/get/user/${publicId}`);
};

const getSelf = () => {
  return httpCommon.get("/v1/get/user/self");
};

const getUserAsAdmin = (userId: number) => {
  return httpCommon.get(`/v1/admin/get/user/${userId}`);
};

// Get all users
const getAllUsers = (businessId: number) => {
  return httpCommon.get(`/v1/get/users/${businessId}`);
};

const getTeamUsers = (businessId: number) => {
  return httpCommon.get(`/v1/get/users/${businessId}`);
};

const getAllUsersAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/users");
};

// Get user count
const getAllUsersCount = () => {
  return httpCommon.get("/v1/get/count/users");
};

const getAllUsersCountAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/count/users");
};

const getUserRoles = () => {
  return httpCommon.get("/v1/get/userRoles");
};

const getUserRolesAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/userRoles");
};

const getUserRolesForUser = (userId: number) => {
  return httpCommon.get(`/v1/get/userRoles/${userId}`);
};

const getUserRolesForUserAsAdmin = (userId: number) => {
  return httpCommon.get(`/v1/admin/get/userRoles/${userId}`);
};

//Add  user
const addUser = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/user/${businessId}`, data);
};

const createUserRole = (data: any) => {
  return httpCommon.post("/v1/add/userRole", data);
};

// Update specific user
const updateSpecificUser = (userId: number, data: any) => {
  return httpCommon.put(`/v1/update/user/${userId}`, data);
};

// Delete user
const deleteUser = (userId: number) => {
  return httpCommon.delete(`/v1/delete/user/${userId}`);
};

const removeUserFromBusiness = (businessId: number, userId: string) => {
  return httpCommon.delete(`/v1/remove/user/${businessId}/${userId}`);
};

const deleteUserRole = (userRoleId: number) => {
  return httpCommon.delete(`/v1/delete/userRole/${userRoleId}`);
};

const UserService = {
    getUser,
    getSelf,
    getUserAsAdmin,
    getAllUsers,
    getAllUsersAsAdmin,
    getAllUsersCount,
    getAllUsersCountAsAdmin,
    getUserRoles,
    getUserRolesAsAdmin,
    getUserRolesForUser,
    getUserRolesForUserAsAdmin,
    addUser,
    createUserRole,
    updateSpecificUser,
    deleteUser,
    removeUserFromBusiness,
    deleteUserRole,
    getTeamUsers
    };
export default UserService;